export default __webpack_public_path__ + "static/P_SearchThumb_IN-9010HD-8c529fbc4dd1ece8865ac680f005dbeb.webp";